import { now } from 'lodash/date';

const epoch = () => Math.floor(now() / 1000);

export const createFordStandardError = (
  status,
  message,
  originalResponse,
  customErrorCode
) => ({
  type: 'https://apiguide.ford.com/metadata/ford-standard-error',
  title: "This error is detailed using Ford's standard error format.",
  status,
  messages: [message],
  attributes: {
    timestamp: epoch(),
  },
  originalResponse,
  customErrorCode,
});
